/**
 * Generic helper for presigned-URL uploads.
 *
 * Usage:
 *   const key = await uploadViaPresigned(file, 'special-mission');
 *   if (key === null) {
 *       // Fallback: let the form submit the file the traditional way
 *   } else {
 *       // Use `key` as the stored value (typically appended to the form as a hidden field)
 *   }
 */
export async function uploadViaPresigned(file, purpose) {
    let signRes;
    try {
        const body = new FormData();
        body.append('purpose', purpose);
        body.append('content_type', file.type);
        signRes = await fetch('/api/upload/sign', {
            method: 'POST',
            body,
            credentials: 'same-origin',
        });
    } catch (_) {
        return null;
    }
    if (!signRes.ok) return null;

    const data = await signRes.json().catch(() => null);
    if (!data) return null;
    if (data.mode === 'local') return null;
    if (data.mode !== 's3' || !data.url || !data.key) return null;

    try {
        const putRes = await fetch(data.url, {
            method: 'PUT',
            body: file,
            headers: { 'Content-Type': file.type },
        });
        if (!putRes.ok) return null;
        return data.key;
    } catch (_) {
        return null;
    }
}
